<template>
  <div class="product">
    <!-- 顶部操作按钮与搜索区封装为组件 -->
    <v-search-subscribe
      :search="search"
      v-on:onSubmit="onSubmit"
      v-on:resetSearch="resetSearch"
      v-on:accountDeductions="handleAccountDeductions"
      v-on:stop="handleStop"
      v-on:consolidate="handleConsolidate"
    ></v-search-subscribe>

    <!-- 列表：参照原型 -->
    <div class="vue-padding radius">
      <el-table class="subscribe-table" stripe highlight-current-row v-loading="loading" :data="dataList" :empty-text="$t('common.noData')" :element-loading-text="$t('common.loading')" style="width: 100%" max-height="638" :border="true">
        <el-table-column prop="stripeSubscriptionId" :label="$t('subscribe.table.subscriptionId')" :align="'center'" :show-overflow-tooltip="true" :formatter="formatStripeSubscriptionId"></el-table-column>
        <el-table-column prop="deviceCount" :label="$t('subscribe.table.deviceCount')" :align="'center'"></el-table-column>
        <el-table-column prop="deviceList" :label="$t('subscribe.table.deviceList')" :align="'center'">
          <template slot-scope="scope">
            <template v-if="scope.row.deviceList && !scope.row.deviceListIsView">
              <el-link type="primary" @click="viewDevices(scope.row)">{{ scope.row.deviceList }}</el-link>
            </template>
            <template v-else>
              <el-link type="primary" @click="viewDevices(scope.row)">{{ $t('subscribe.table.view') }}</el-link>
            </template>
          </template>
        </el-table-column>
        <el-table-column prop="statusLabel" :label="$t('subscribe.table.status')" :align="'center'">
          <template slot-scope="scope">
            <span class="status-wrapper">
              <!-- <i :class="['status-dot', statusClass(scope.row)]"></i> -->
              <span>{{ scope.row.statusLabel }}</span>
            </span>
          </template>
        </el-table-column>
        <!-- 新增：订阅状态（接口字段 stripeSubscriptionState），位于订单状态之后 -->
        <el-table-column prop="subscriptionStateLabel" :label="$t('subscribe.table.subscriptionStatus')" :align="'center'" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <span class="status-wrapper">
              <i :class="['status-dot', subscriptionStatusClass(scope.row)]"></i>
              <span>{{ scope.row.subscriptionStateLabel }}</span>
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="typeLabel" :label="$t('subscribe.table.type')" :align="'center'"></el-table-column>
        <!-- 操作列已注释，若需恢复请去掉以下注释 -->
        <!--
        <el-table-column :label="$t('subscribe.table.operation')" :width="$i18n.locale == 'zh_CN' ? 150 : 155" :align="'center'">
          <template slot-scope="scope">
            <el-link type="primary" @click="viewDetails(scope.row)">{{ $t('subscribe.table.viewDetails') }}</el-link>
          </template>
        </el-table-column>
        -->
      </el-table>
      <el-pagination v-if="page.totalSize > 0" background layout="total,sizes,prev, pager, next,jumper" :current-page="page.pageIndex" :total="page.totalSize" @size-change="sizeChange" :page-size="page.pageSize" @current-change="currentChange"></el-pagination>
    </div>

    <!-- 设备列表弹窗 -->
    <el-dialog :title="$t('renewalRecord.machine')"
               :modal-append-to-body="true"
               :append-to-body="true"
               top="6vh"
               class="subscribe-device-dialog"
               :visible.sync="deviceDialogVisible"
               width="680px">
      <el-table :data="deviceDialogList" :empty-text="$t('common.noData')" style="width: 100%">
        <el-table-column property="name" :label="$t('renewalRecord.equipmentName')"></el-table-column>
        <el-table-column property="equipmentNo" :label="$t('renewalRecord.equipmentNo')"></el-table-column>
        <el-table-column property="date" :label="$t('renewalRecord.expireDate')"></el-table-column>
        <el-table-column v-if="currentSubscriptionRow && !isSubscriptionCancelled(currentSubscriptionRow)" :label="$t('subscribe.table.operation')" :align="'center'" width="130">
          <template slot-scope="scope">
            <el-tag v-if="scope.row._cancelled" type="info" size="mini" disable-transitions>
              {{ $t('subscribe.statusLabels.cancelled') }}
            </el-tag>
            <el-button
              v-else
              type="danger"
              size="mini"
              plain
              :loading="scope.row._cancelling"
              @click="confirmCancelMachine(scope.row)"
            >{{ $t('subscribe.actions.cancelMachine') }}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="deviceDialogVisible = false">{{ $t('common.close') }}</el-button>
      </span>
    </el-dialog>

    <!-- 订阅说明弹框：点击 Account for deductions 显示 -->
    <el-dialog :title="$t('subscribe.instructions.title')"
               :modal-append-to-body="true"
               :append-to-body="true"
               top="6vh"
               :visible.sync="instructionsDialogVisible"
               width="640px"
               class="subscription-instructions">
      <div class="instructions">
        <p><strong>{{ $t('subscribe.instructions.checkUnsubscribedTitle') }}</strong></p>
        <p>{{ $t('subscribe.instructions.checkUnsubscribedContent') }}</p>

        <p><strong>{{ $t('subscribe.instructions.newVsExistingTitle') }}</strong></p>
        <p>{{ $t('subscribe.instructions.newVsExistingContent') }}</p>

        <p><strong>{{ $t('subscribe.instructions.paymentMethodTitle') }}</strong></p>
        <p>{{ $t('subscribe.instructions.paymentMethodContent') }}</p>

        <p><strong>{{ $t('subscribe.instructions.startSubscriptionTitle') }}</strong></p>
        <p>{{ $t('subscribe.instructions.startSubscriptionContent') }}</p>

        <p><strong>{{ $t('subscribe.instructions.subscriptionPaymentTitle') }}</strong></p>
        <p>{{ $t('subscribe.instructions.subscriptionPaymentContent') }}</p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="instructionsDialogVisible = false">{{ $t('subscribe.instructions.ok') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import vSearchSubscribe from "@/components/mywallet/SearchSubscribe";
export default {
  name: "Subscribe",
  components: { vSearchSubscribe },
  data() {
    return {
      loading: false,
      search: {
        SubscriptionId: "",
        machineName: "",
        machineNo: ""
      },
      page: {
        pageSize: 10,
        pageIndex: 1,
        totalSize: 0
      },
      dataList: [],
      rentStateList: [],
      deviceDialogVisible: false,
      deviceDialogList: [],
      currentSubscriptionRow: null,
      instructionsDialogVisible: false,
      cancelledEquipmentNos: []
    };
  },
  mounted() {
    this.listRenewalStatus();
    this.currentChange();
  },
    methods: {
      // 列格式化：订阅ID为空时显示"-"
      formatStripeSubscriptionId(row, column, cellValue) {
        if (cellValue === null || cellValue === undefined) return '-';
        const str = String(cellValue).trim();
        return str.length ? str : '-';
      },
      // 顶部按钮
      handleAccountDeductions() {
        // 打开订阅说明弹窗
        this.instructionsDialogVisible = true;
      },
    // 模仿 MachineRenewal.vue：点击 strip 在新窗口打开并跳转到 Stripe 绑定银行卡页面
    async handleStop() {
      // 先同步打开一个新窗口，避免浏览器拦截
      const newWin = window.open('', '_blank');
      try {
        // 优先尝试获取 Stripe 客户门户链接（包含银行卡管理/绑定）
        const portal = await this.$api.request(this.$url.Stripe.machineGetUrl, this.$method.get, {});
        const url = portal?.data?.url || portal?.data?.href || portal?.data;
        if (portal && portal.code === 0 && url) {
          if (newWin) {
            newWin.location.href = url;
          } else {
            window.location.href = url;
          }
          return;
        }
      } catch (e) {
        // ignore and try fallback
      }

      try {
        // 回退：尝试后端提供的创建/添加 Stripe 流程入口
        const addRes = await this.$api.request(this.$url.Stripe.add, this.$method.get, {});
        const addUrl = addRes?.data?.url || addRes?.data?.href || addRes?.data;
        if (addRes && addRes.code === 0 && addUrl) {
          if (newWin) {
            newWin.location.href = addUrl;
          } else {
            window.location.href = addUrl;
          }
          return;
        }
      } catch (e) {
        // ignore
      }

      // 如果无法获取链接，关闭空白窗口并提示
      if (newWin && newWin.close) {
        try { newWin.close(); } catch (_) {}
      }
      this.$message.warning(this.$t('subscribe.messages.cannotJumpCardPortal'));
    },
    handleConsolidate() {
      this.loading = true;
      this.$api.request(this.$url.Stripe.consolidate, this.$method.post, {})
        .then(res => {
          this.loading = false;
          if (res && res.code === 0) {
            this.$message.success(this.$t('subscribe.messages.consolidateSuccess'));
            this.currentChange(this.page.pageIndex);
          } else {
            this.$message.error((res && res.msg) || this.$t('subscribe.messages.consolidateFailed'));
          }
        })
        .catch(() => {
          this.loading = false;
          this.$message.error(this.$t('subscribe.messages.consolidateFailed'));
        });
    },
    // 搜索
    onSubmit() {
      this.page.pageIndex = 1;
      this.currentChange();
    },
    resetSearch() {
      this.search.SubscriptionId = "";
      this.search.machineName = "";
      this.search.machineNo = "";
      this.page.pageIndex = 1;
      this.currentChange();
    },
    // 加载数据（接入 rentRecord/page）
    currentChange(pageIndex) {
      this.loading = true;
      this.page.pageIndex = pageIndex ? pageIndex : 1;
      // 将搜索条件映射到接口可识别字段
      const query = {
        equipmentNo: this.search.machineNo || undefined, // 机器编号
        stripeSubscriptionId: this.search.SubscriptionId || undefined, // 订阅
        equipmentName: this.search.machineName || undefined, // 设备名称
        pageIndex: this.page.pageIndex,
        pageSize: this.page.pageSize
      };
      this.$api
        .request(this.$url.RenewalRecord.page, this.$method.get, query)
        .then(res => {
          if (res.code === 0 && res.data) {
            const records = Array.isArray(res.data.records) ? res.data.records : [];
            this.page.totalSize = parseInt(res.data.total || records.length);
            this.dataList = records.map(r => this.formatRecord(r));
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
      this.currentChange();
    },
    viewDevices(row) {
      const raw = row._raw || {};
      this.currentSubscriptionRow = row;
      this.deviceDialogList = (raw.rentEquipment || []).map(d => ({
        ...d,
        _cancelling: false,
        _cancelled: !!d.subscriptionCancelled || (this.cancelledEquipmentNos.includes(d.equipmentNo) && !d.stripeSubscriptionId)
      }));
      this.deviceDialogVisible = true;
    },
    isSubscriptionCancelled(row) {
      const raw = row._raw || {};
      const state = String(raw.stripeSubscriptionState || '').toLowerCase();
      return state === 'canceled' || state === 'cancelled';
    },
    confirmCancelMachine(device) {
      const machineName = device.name || device.equipmentNo || '';
      this.$confirm(
        this.$t('subscribe.messages.confirmCancelMachine', { name: machineName }),
        this.$t('subscribe.messages.confirmCancelTitle'),
        {
          confirmButtonText: this.$t('subscribe.actions.confirmCancel'),
          cancelButtonText: this.$t('common.cancel') || 'Cancel',
          type: 'warning'
        }
      ).then(() => {
        this.cancelMachineSubscription(device);
      }).catch(() => {});
    },
    cancelMachineSubscription(device) {
      const raw = this.currentSubscriptionRow ? (this.currentSubscriptionRow._raw || {}) : {};
      const subscriptionId = raw.stripeSubscriptionId || '';
      const equipmentNo = device.equipmentNo || '';
      const machineName = device.name || equipmentNo;
      const equipmentId = device.id || device.equipmentId || undefined;

      this.$set(device, '_cancelling', true);

      this.$api.request(
        this.$url.Stripe.cancelSubscriptionItem,
        this.$method.post,
        { stripeSubscriptionId: subscriptionId, equipmentNo, equipmentId }
      ).then(res => {
        this.$set(device, '_cancelling', false);
        if (res && res.code === 0) {
          this.$set(device, '_cancelled', true);
          if (!this.cancelledEquipmentNos.includes(equipmentNo)) {
            this.cancelledEquipmentNos.push(equipmentNo);
          }
          this.$message.success(this.$t('subscribe.messages.cancelMachineSuccess', { name: machineName, equipmentNo }));
          this.currentChange(this.page.pageIndex);
        } else {
          this.$message.error((res && res.msg) || this.$t('subscribe.messages.cancelMachineFailed'));
        }
      }).catch(() => {
        this.$set(device, '_cancelling', false);
        this.$message.error(this.$t('subscribe.messages.cancelMachineFailed'));
      });
    },
    viewDetails(row) {
      const raw = row._raw || {};
      // 可根据需要跳转到续费详情或弹窗，这里先简单提示
      this.$message.info(`${this.$t('common.info') || 'Details'}: ${raw.stripeSubscriptionId || row.stripeSubscriptionId}`);
    },
    listRenewalStatus() {
      // 加载续费状态字典，用于状态文案
      this.$api.dict('gp_renewal_status').then(res => {
        if (res.code === 0) {
          this.rentStateList = res.data || [];
        }
      });
    },
    formatRecord(r) {
      const deviceCount = r.rentEquipment ? r.rentEquipment.length : 0;
      const deviceListIsView = deviceCount !== 1;
      const deviceList = deviceCount === 1 ? (r.rentEquipment[0].equipmentNo || this.$t('subscribe.table.view')) : this.$t('subscribe.table.view');
      let statusLabel = this.$cloud ? this.$cloud.getDictLabel(this.rentStateList, r.state) : r.state;
      // Replace "Rejected" with "Cancelled" for subscription status
      if (statusLabel && statusLabel.toLowerCase() === 'rejected') {
        statusLabel = 'Cancelled';
      }
      const typeLabel = r.stripeSubscriptionPayType == 1 ? this.$t('subscribe.type.monthly') : this.$t('subscribe.type.yearly');
      // 统一展示：本地化且首字母大写的订阅状态
      const rawState = String(r.stripeSubscriptionState || '').trim();
      const subscriptionStateLabel = this.getSubscriptionStateLabel(rawState.toLowerCase());
      
      // If subscription is cancelled, update the status to show Cancelled
      if (rawState.toLowerCase() === 'canceled' || rawState.toLowerCase() === 'cancelled') {
        statusLabel = 'Cancelled';
      }
      
      return {
        stripeSubscriptionId: r.stripeSubscriptionId || '',
        deviceCount,
        deviceList,
        deviceListIsView,
        statusLabel,
        subscriptionStateLabel,
        typeLabel,
        _raw: r
      };
    },
    statusClass(row) {
      const text = (row.statusLabel || '').toLowerCase();
      // 粗略判断：包含 active/success/valid 视为绿色；其他红色
      if (text.includes('active') || text.includes('success') || text.includes('valid')) {
        return 'status-green';
      }
      return 'status-red';
    },
    // 订阅状态颜色映射（stripeSubscriptionState）：
    // active(活跃) -> 绿色；trialing(试用) -> 蓝色；
    // past_due(续费失败) -> 橙色；
    // canceled(已取消)、incomplete_expired(支付超时) -> 灰色；
    // incomplete(首次扣款失败)、unpaid(欠费) -> 红色。
    // 文案映射：返回本地化且首字母大写的展示文本
    getSubscriptionStateLabel(state) {
      const s = String(state || '').toLowerCase();
      if (!s) return '';
      if (s === 'active') return this.$t('subscribe.statusLabels.active');
      if (s === 'trialing' || s === 'on_trial') return this.$t('subscribe.statusLabels.onTrial');
      if (s === 'canceled' || s === 'cancelled') return this.$t('subscribe.statusLabels.cancelled');
      // 其他状态：按单词首字母大写
      return this.capitalizeState(s);
    },
    // 将任意传入状态（原始/本地化/标题大小写）统一为标准 key
    normalizeSubscriptionStateKey(val) {
      const s = String(val || '').trim();
      if (!s) return '';
      const lower = s.toLowerCase().replace(/[\s-]+/g, '_');
      // 兼容标题大小写文案
      if (lower === 'active') return 'active';
      if (lower === 'on_trial' || lower === 'trialing') return 'trialing';
      if (lower === 'cancelled' || lower === 'canceled') return 'canceled';
      if (lower === 'past_due') return 'past_due';
      if (lower === 'incomplete_expired') return 'incomplete_expired';
      if (lower === 'incomplete') return 'incomplete';
      if (lower === 'unpaid') return 'unpaid';
      return lower;
    },
    capitalizeState(s) {
      return String(s)
        .split(/[_\s-]+/)
        .map(w => (w ? w.charAt(0).toUpperCase() + w.slice(1) : w))
        .join(' ');
    },
    subscriptionStatusClass(row) {
      const raw = row._raw || {};
      const source = raw.stripeSubscriptionState || row.subscriptionStateLabel || '';
      const key = this.normalizeSubscriptionStateKey(source);
      switch (key) {
        case 'active':
          return 'status-green';
        case 'trialing':
          return 'status-blue';
        case 'past_due':
          return 'status-orange';
        case 'canceled':
        case 'incomplete_expired':
          return 'status-gray';
        case 'incomplete':
        case 'unpaid':
          return 'status-red';
        default:
          return 'status-gray';
      }
    }
  }
};
</script>

<style scoped>
.el-tag--mini {
  margin-right: 5px;
}
.status-wrapper {
  display: inline-flex;
  align-items: center;
}
.status-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  display: inline-block;
  margin-right: 6px;
}
.status-green {
  background-color: var(--vtm-ok);
}
.status-red {
  background-color: var(--vtm-crit);
}
/* 订阅状态扩展颜色 */
.status-blue {
  background-color: var(--vtm-info);
}
.status-orange {
  background-color: var(--vtm-warn);
}
.status-gray {
  background-color: var(--vtm-ink-3);
}
</style>
<style scoped lang="scss">
/* Subscribe 列表样式优化 */
::v-deep .subscribe-table {
  border-radius: 8px;
  overflow: hidden;
}
::v-deep .subscribe-table .el-table__header th {
  background-color: var(--vtm-surface-2);
  color: var(--vtm-ink);
  font-weight: 600;
}
::v-deep .subscribe-table .el-table__header th .cell {
  padding: 10px 0;
}
::v-deep .subscribe-table .el-table__body td .cell {
  padding: 8px 0;
}
/* 行悬浮效果与斑马纹更柔和 */
::v-deep .subscribe-table .el-table__body tr:hover > td {
  background-color: var(--vtm-well);
}
/* 可点击链接样式微调 */
::v-deep .subscribe-table .el-link {
  font-size: 13px;
}

/* 订阅说明弹框样式 */
::v-deep .subscription-instructions .el-dialog__body {
  color: var(--vtm-ink);
  font-size: 14px;
  line-height: 1.6;
}
::v-deep .subscription-instructions .instructions p {
  margin: 6px 0;
}
::v-deep .subscription-instructions .instructions strong {
  display: inline-block;
  margin-bottom: 2px;
}
</style>